import React from "react";
import { useDispatch, useSelector } from "react-redux";

import FooterItem from "./FooterItem/FooterItem";
import Slider from "react-slick";

import styles from "./Footer.module.scss";
import { toggleRecentActivitySuggestions } from "../../BottomSheets/store/actions";
import { getAwsAssets } from "@src/utils";

const Footer = () => {
  // DISPATCH
  const dispatch = useDispatch();

  const showPrompt = () => {
    dispatch(toggleRecentActivitySuggestions(true));
  };

  // SELECTORS
  const priorityOrderList = useSelector(
    (state) =>
      state?.overviewReducer?.overViewDetails?.course?.priorityOrderList
  );

  const postPurchaseData = useSelector(state => state?.overviewReducer?.overViewDetails?.course?.metaData?.postPurchaseData);

  // SETTINGS
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    dotsClass: `${styles.FooterDots} slick-dots`,
  };

  return (
    <div>
      {postPurchaseData ?
      <div className="newAdSmallCard">
        <div className="newAdSmallCard__imageWrapper">
        <img src={postPurchaseData?.imageUrl} alt="" className="newAdSmallCard__image" />
        </div>
        <div className="newAdSmallCard__headingWrapper">
          <div className="newAdSmallCard__heading">{postPurchaseData?.heading}</div>
          <div className="newAdSmallCard__subHeading">{postPurchaseData?.subHeading}</div>
        </div>
        <button
            className="newAdSmallCard__button"
            onClick={() => {
                    window?.mobile?.onDeeplinkExecutedV2(
                      JSON.stringify(postPurchaseData?.emblem?.deeplink)
                    );
                    window?.webkit?.messageHandlers?.onDeeplinkExecutedV2?.postMessage(
                      JSON.stringify(postPurchaseData?.emblem?.deeplink)
                    );
                  }
            }
          >
            {postPurchaseData?.emblem.text}
            <img src={getAwsAssets("external-link.svg", "content")} alt="" />
          </button>
      </div> 
      :
      <Slider {...settings}>
        {priorityOrderList?.map((item, i) => (
          <FooterItem key={i} remove={showPrompt} {...item} />
        ))}
      </Slider>
      }
    </div>
  );
};

export default Footer;
